import { useState, useMemo } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import CourseFilter from "./components/CourseFilter";
import LearningRoadmap from "./components/LearningRoadmap";
import type { CourseLevel } from "./components/LearningRoadmap";
import CourseCalendar from "./components/CourseCalendar";
import { useCourses } from "@/hooks/useCourses";
import { motion } from "motion/react";

export default function CoursesPage() {
  const [activeLevel, setActiveLevel] = useState<CourseLevel>("all");
  const { courses } = useCourses();

  const courseCounts = useMemo(() => {
    const counts: Record<CourseLevel, number> = {
      all: courses.length,
      입문: 0,
      실전: 0,
      마스터: 0,
    };
    courses.forEach((c) => {
      if (c.level === "입문") counts.입문 += 1;
      if (c.level === "실전") counts.실전 += 1;
      if (c.level === "마스터") counts.마스터 += 1;
    });
    return counts;
  }, [courses]);

  return (
    <div className="min-h-screen bg-[#FAFAF8] font-['Noto_Sans_KR']">
      <Navbar />
      <main className="pt-24 pb-16 px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          {/* Page Header */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, ease: [0.25, 0.1, 0.25, 1] as const }}
            className="mb-8"
          >
            <div className="flex items-center gap-2 mb-2">
              <i className="ri-book-open-line text-[#C4956A]"></i>
              <span className="text-xs font-medium text-[#C4956A]">교육과정</span>
            </div>
            <h1 className="text-2xl md:text-3xl font-bold text-[#1C1917] mb-2">
              교육과정
            </h1>
            <p className="text-sm text-[#8C8780]">
              무료 입문부터 실전 투자까지, 체계적인 커리큘럼으로 경매의 모든 것을 배워보세요
            </p>
          </motion.div>

          {/* Learning Roadmap */}
          <LearningRoadmap
            activeLevel={activeLevel}
            onLevelChange={setActiveLevel}
            courseCounts={courseCounts}
          />

          {/* Course Calendar */}
          <CourseCalendar />

          {/* Course Filter & Grid */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.15, duration: 0.5, ease: [0.25, 0.1, 0.25, 1] as const }}
          >
            <CourseFilter activeLevel={activeLevel} courses={courses} />
          </motion.div>
        </div>
      </main>
      <Footer />
    </div>
  );
}